import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Products from './Products';
import AddEditProduct from './AddEditProduct/AddEditProduct';
import Inventory from './Inventory/Inventory';
import OrderAdjustProduct from './OrderProduct/OrderAdjustProduct';

export const ProductsRoutes = (
  <Route path="products" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <Products />
        </PrivateRoute>
            )}
    />

    <Route
      path="add"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <AddEditProduct />
        </PrivateRoute>
            )}
    />

    <Route
      path=":productId/edit"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <AddEditProduct edit />
        </PrivateRoute>
            )}
    />

    <Route
      path=":productId/inventory"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <Inventory />
        </PrivateRoute>
            )}
    />

    <Route
      path="order"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <OrderAdjustProduct />
        </PrivateRoute>
            )}
    />

    <Route
      path="orders/:adjustId"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <OrderAdjustProduct edit />
        </PrivateRoute>
            )}
    />

    <Route
      path="adjust"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <OrderAdjustProduct adjust />
        </PrivateRoute>
            )}
    />

    <Route
      path="adjustments/:adjustId"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <OrderAdjustProduct adjust edit />
        </PrivateRoute>
            )}
    />

  </Route>
);
